import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { GeneralAdminState, initialStoreState } from './general-admin.model';
import { OrganisationDto } from '../../core/models/organisation-dto';
import { UnitOfMeasureDto } from '../../core/models/unit-of-measure-dto';

export interface GState extends EntityState<GeneralAdminState, number> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'general-admin' })
export class GeneralAdminStore extends EntityStore<GState> {
  constructor() {
    super(initialStoreState);
  }

  setOrganisations(organisations: OrganisationDto[]) {
    this.update({ organisations });
  }

  setUnitOfMeasure(unitOfMeasure: UnitOfMeasureDto[]) {
    this.update({ unitOfMeasure });
  }

  setCurrencies(currencies: string[]) {
    this.update({ currencies });
  }
}
